// src/components/organisms/auth/auth-aside/auth-aside.tsx
import { cn } from "@/lib/utils";
import { AuthSocialProof } from "@/components/molecules/auth/auth-social-proof";
import type { TestimonialAvatarItem } from "@/components/atoms/landing/testimonial-avatar";

export type AuthAsideContent = {
  heading: React.ReactNode;
  description: React.ReactNode;
  socialProof: {
    stars: number;
    trustLine: React.ReactNode;
    avatars: TestimonialAvatarItem[];
  };
};

/** Flat deep-purple promo panel shown on the right of auth pages (lg+). */
export function AuthAside({
  content,
  className,
}: {
  content: AuthAsideContent;
  className?: string;
}) {
  return (
    <aside
      className={cn(
        "relative hidden overflow-hidden bg-brand-ink lg:flex lg:flex-col lg:justify-end",
        className,
      )}
    >
      <div className="flex flex-col gap-10 p-12 xl:p-16">
        <div className="flex flex-col gap-6">
          <h2 className="max-w-xl font-display text-5xl font-bold leading-[1.05] tracking-tight text-white xl:text-6xl">
            {content.heading}
          </h2>
          <p className="max-w-md text-lg leading-relaxed text-white/70">
            {content.description}
          </p>
        </div>
        <AuthSocialProof {...content.socialProof} />
      </div>
    </aside>
  );
}
